<script>
//全局路径
const globalPath = {
    api: "/api/", //主页调用接口地址
    wsUrl: process.env.WS_URL,
    url: '/url/',
    DL:"/DL/",
    sdkEvn : 'sbox'
}

//顺丰打印环境配置 sdkEvn : 'pro'
if(process.env.NODE_ENV === 'trial' || 
    process.env.NODE_ENV === 'production' || 
    process.env.NODE_ENV === 'presentation'|| 
    process.env.NODE_ENV === 'qualityAssurance' ||
    process.env.NODE_ENV === 'presentationCustomer' ||
    process.env.NODE_ENV === 'productionCustomer' ||
    process.env.NODE_ENV === 'qualityAssuranceCustomer'
){
    console.log("环境配置：" + process.env.API_ROOT)
    globalPath.api = process.env.API_ROOT + "api/";
    globalPath.url = process.env.API_ROOT + 'download/downLoadTemplate/';
    globalPath.DL = process.env.API_ROOT;
    globalPath.sdkEvn = 'pro';
}
export default {
    globalPath
};
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue